import { render } from "./ContactoTables.vue?vue&type=template&id=3a4908e4"
import script from "./ContactoTables.vue?vue&type=script&lang=js"
export * from "./ContactoTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__